import { render, staticRenderFns } from "./hasChildQuestion.vue?vue&type=template&id=0f30e2eb&"
import script from "./hasChildQuestion.vue?vue&type=script&lang=js&"
export * from "./hasChildQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports